import ArchiveIcon from '@mui/icons-material/Archive'
import DescriptionIcon from '@mui/icons-material/Description'
import EditIcon from '@mui/icons-material/Edit'
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined'
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import { Fragment, useState } from 'react'

import type { MenuProps } from '@mui/material'
import type {
    RosterProfileQuery,
    RosterProfileQueryVariables,
} from '__generated__/graphql'
import RosterDrawer from 'recruiter/components/RosterDrawer'
import ShareRosterModal from 'recruiter/components/ShareRosterModal'
import type { ApolloQueryRefetchFunction } from 'shared/types/graphql'
import ArchiveRosterDialog from '../ArchiveRoster/ArchiveRosterDialog'
import PitchNotes from '../PitchNotes'

interface ActionsMenuProps extends MenuProps {
    data: RosterProfileQuery['roster']
    handleClose: () => void
    refetch: ApolloQueryRefetchFunction<
        RosterProfileQuery,
        RosterProfileQueryVariables
    >
}

const ActionsMenu = ({
    open,
    anchorEl,
    data,
    handleClose,
    refetch,
}: ActionsMenuProps) => {
    const [openArchiveDialog, setOpenArchiveDialog] = useState(false)
    const [openPitchNote, setOpenPitchNote] = useState(false)
    const [editRosterDrawerOpen, setEditRosterDrawerOpen] = useState(false)
    const [showShareRosterDialog, setShowShareRosterDialog] = useState(false)

    const handleOpenArchiveDialog = () => setOpenArchiveDialog(true)
    const handleCloseArchiveDialog = () => {
        setOpenArchiveDialog(false)
        handleClose()
    }
    const handleOpenPitchNote = () => {
        setOpenPitchNote(true)
        handleClose()
    }
    const handleClosePitchNote = () => {
        setOpenPitchNote(false)
        handleClose()
    }
    const handleEditRoster = () => {
        setEditRosterDrawerOpen(true)
        handleClose()
    }

    const handleShowShareRoster = () => {
        setShowShareRosterDialog(true)
        handleClose()
    }

    return (
        <Fragment>
            <Menu
                id="action-menu"
                anchorEl={anchorEl}
                open={open}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'action-button',
                }}
                sx={{
                    border: '1px solid',
                    borderColor: 'other.lightBorder',
                }}
            >
                <MenuItem onClick={handleOpenPitchNote}>
                    <ListItemIcon>
                        <DescriptionIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Pitch Notes" />
                </MenuItem>
                <MenuItem onClick={handleEditRoster}>
                    <ListItemIcon>
                        <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Edit" />
                </MenuItem>
                {data?.status !== 'Closed' && (
                    <MenuItem onClick={handleOpenArchiveDialog}>
                        <ListItemIcon>
                            <ArchiveIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Archive" />
                    </MenuItem>
                )}
                <MenuItem onClick={handleShowShareRoster}>
                    <ListItemIcon>
                        <IosShareOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Share" />
                </MenuItem>
            </Menu>
            <ArchiveRosterDialog
                open={openArchiveDialog}
                onClose={handleCloseArchiveDialog}
                rosterId={data?.id ?? ''}
                refetch={refetch}
            />
            <PitchNotes
                open={openPitchNote}
                onClose={handleClosePitchNote}
                data={data}
                refetch={refetch}
            />
            <RosterDrawer
                type={editRosterDrawerOpen ? 'edit' : undefined}
                presetRosterType={data?.rosterType}
                onClose={() => setEditRosterDrawerOpen(false)}
                rosterId={data?.id ?? ''}
                selectedCandidates={[]}
                refetch={refetch}
            />
            <ShareRosterModal
                rosterId={data?.id ?? ''}
                open={showShareRosterDialog}
                onClose={() => setShowShareRosterDialog(false)}
                refetch={refetch}
            />
        </Fragment>
    )
}

export default ActionsMenu
